(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import axios from 'axios';
import { ReCaptcha, loadReCaptcha } from 'react-recaptcha-v3';
import '../assets/styles/components/ContactUs.scss';
import { updateToken, PUBLIC_KEY } from '../../server/utils/recaptcha';
import Input from './custom/formControl/Input';
import Form from './custom/formControl/Form';
import TextArea from './custom/formControl/TextArea';
import Select from './custom/formControl/Select';
const initialState = {
  name: '',
  lastName: '',
  email: '',
  phone: '',
  roommates: '',
  preferToLive: '',
  sharing: '',
  // property: '',
  // message: '',
  sendInformation: true,
  token: ''
};
class FormRoommateFinder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validated: false,
      success: false,
      form: {
        ...initialState
      },
      loading: false,
      error: false,
      captcha: true
    };
    this.isLoadedRecaptcha = false;
    this.recaptchaRef = /*#__PURE__*/React.createRef();
    this.formRef = /*#__PURE__*/React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleChangeCaptcha = this.handleChangeCaptcha.bind(this);
    this.onCaptchaExpired = this.onCaptchaExpired.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadCaptcha = this.loadCaptcha.bind(this);
    this.handleclose = this.handleclose.bind(this);
  }
  handleclose() {
    this.setState({
      success: false,
      error: false
    });
  }
  verifyCallback(token) {
    // console.log('token', token);
    const {
      form
    } = this.state;
    this.setState({
      form: {
        ...form,
        token,
        captcha: !!token
      }
    });
  }
  loadCaptcha() {
    if (!this.isLoadedRecaptcha) {
      loadReCaptcha(PUBLIC_KEY, res => {
        // console.log('loadReCaptcha', res);
        this.isLoadedRecaptcha = true;
      });
    }
  }
  handleChange(event) {
    const {
      form
    } = this.state;
    const {
      value
    } = event.target;
    const isBool = event.target.type === 'radio' && (value === 'true' || value === 'false');
    const finalValue = isBool ? value === 'true' : value;
    this.setState({
      form: {
        ...form,
        [event.target.name]: finalValue
      }
    });
    this.loadCaptcha();
  }
  handleCheckChange(event) {
    const {
      form
    } = this.state;
    this.setState({
      form: {
        ...form,
        [event.target.name]: event.target.checked
      }
    });
  }
  handleChangeCaptcha(value) {
    this.state.setState({
      captcha: true
    });
  }
  onCaptchaExpired() {
    this.state.setState({
      captcha: false
    });
  }
  handleSubmit(event) {
    // this.loadCaptcha();
    const formControl = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    // console.log(`formControl.checkValidity()`, formControl.checkValidity());
    const {
      form
    } = this.state;
    // console.log('form', form);

    if (formControl.checkValidity() !== false) {
      this.setState({
        loading: true
      });
      updateToken(this.recaptchaRef).then(token => {
        if (!token) {
          this.setState({
            captcha: false,
            validated: true
          });
        } else {
          this.setState({
            loading: true
          });
          form.token = token;
          axios.post('roommateFinders', form).then(({
            data
          }) => {
            // console.log('data', data);
            if (data.body && data.body._id) {
              // console.log('this.formRef', this.formRef);
              // this.formRef.current.reset();
              this.setState({
                success: true,
                loading: false,
                validated: false,
                form: {
                  ...initialState
                }
              });
            } else {
              // console.log('data', data);
              this.setState({
                success: false,
                error: true,
                loading: false
              });
            }
          }).catch(err => {
            console.log('err', err);
            this.setState({
              success: false,
              error: true,
              loading: false
            });
            // this.updateToken();
          });
        }
      }).catch(error => {
        console.log('Get token error:', error);
        this.setState({
          captcha: false,
          validated: true
        });
      });
    } else {
      // document.querySelectorAll(".was-validated :invalid ~ .invalid-feedback")
      this.setState({
        validated: true
      });
    }
  }

  // componentDidMount() {
  //   loadReCaptcha(PUBLIC_KEY, (res) => // console.log('loadReCaptcha', res));
  // }

  render() {
    // console.log('this.state :>> ', this.state);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form, {
      onSubmit: this.handleSubmit,
      ref: this.formRef,
      validated: this.state.validated
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-roommate"
    }, /*#__PURE__*/React.createElement("div", {
      className: "form-group grid-roommate__name"
    }, /*#__PURE__*/React.createElement(Input, {
      type: "text",
      id: "name",
      onChange: this.handleChange,
      name: "name",
      value: this.state.form.name,
      label: "First Name",
      required: true,
      maxLength: "30"
    })), /*#__PURE__*/React.createElement("div", {
      className: "form-group grid-roommate__lastName"
    }, /*#__PURE__*/React.createElement(Input, {
      type: "text",
      id: "lastName",
      onChange: this.handleChange,
      name: "lastName",
      value: this.state.form.lastName,
      label: "Last Name",
      required: true,
      maxLength: "30"
    })), /*#__PURE__*/React.createElement("div", {
      className: "form-group grid-roommate__email"
    }, /*#__PURE__*/React.createElement(Input, {
      type: "email",
      id: "txtEmail",
      onChange: this.handleChange,
      name: "email",
      value: this.state.form.email,
      label: "Email",
      required: true,
      maxLength: "50"
    })), /*#__PURE__*/React.createElement("div", {
      className: "form-group grid-roommate__phone"
    }, /*#__PURE__*/React.createElement(Input, {
      type: "tel",
      id: "txtPhone",
      name: "phone",
      value: this.state.form.phone,
      onChange: this.handleChange,
      label: "Phone",
      required: true,
      maxLength: "30"
    })), /*#__PURE__*/React.createElement("div", {
      className: "form-group grid-roommate__many"
    }, /*#__PURE__*/React.createElement(Select, {
      id: "ddlmany",
      onChange: this.handleChange,
      name: "roommates",
      value: this.state.form.roommates,
      className: "form-select form-control",
      label: "How many roommates are you looking for?",
      required: true
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Select One"), /*#__PURE__*/React.createElement("option", {
      value: "one"
    }, "One"), /*#__PURE__*/React.createElement("option", {
      value: "two"
    }, "Two"), /*#__PURE__*/React.createElement("option", {
      value: "three"
    }, "Three"), /*#__PURE__*/React.createElement("option", {
      value: "four"
    }, "Four"), /*#__PURE__*/React.createElement("option", {
      value: "five"
    }, "Five"))), /*#__PURE__*/React.createElement("div", {
      className: "form-group grid-roommate__whom"
    }, /*#__PURE__*/React.createElement(Select, {
      id: "ddlWithWhom",
      onChange: this.handleChange,
      name: "preferToLive",
      value: this.state.form.preferToLive,
      className: "form-select form-control",
      label: "With whom do you prefer to live?",
      required: true
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Select One"), /*#__PURE__*/React.createElement("option", {
      value: "Females"
    }, "Females"), /*#__PURE__*/React.createElement("option", {
      value: "Males"
    }, "Males"), /*#__PURE__*/React.createElement("option", {
      value: "Any"
    }, "Any"), /*#__PURE__*/React.createElement("option", {
      value: "No preference"
    }, "No preference"))), /*#__PURE__*/React.createElement("div", {
      className: "form-group grid-roommate__sharing"
    }, /*#__PURE__*/React.createElement(Select, {
      id: "ddlsharing",
      onChange: this.handleChange,
      name: "sharing",
      value: this.state.form.sharing,
      className: "form-select form-control",
      label: "Are you opening to sharing a bedroom?",
      required: true
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Select One"), /*#__PURE__*/React.createElement("option", {
      value: "Yes"
    }, "Yes"), /*#__PURE__*/React.createElement("option", {
      value: "No"
    }, "No"))), /*#__PURE__*/React.createElement("fieldset", {
      className: "form-group grid-roommate__check"
    }, /*#__PURE__*/React.createElement("legend", null, "Do you want to receive email notifications, news, and specials from us?"), /*#__PURE__*/React.createElement("div", {
      className: "form-group d-flex"
    }, /*#__PURE__*/React.createElement("div", {
      className: "form-check"
    }, /*#__PURE__*/React.createElement("input", {
      name: "sendInformation",
      required: true,
      type: "radio",
      id: "sendInformationYes",
      className: "form-check-input mr-1",
      value: true,
      checked: this.state.form.sendInformation,
      onChange: this.handleChange
      // defaultValue="true"
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: "sendInformationYes",
      className: "form-check-label mr-2"
    }, "Yes ", /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "yes send information")), /*#__PURE__*/React.createElement("input", {
      name: "sendInformation",
      required: true,
      type: "radio",
      id: "sendInformationNo",
      className: "form-check-input mr-1",
      value: false,
      checked: this.state.form.sendInformation === false,
      onChange: this.handleChange
      // defaultValue="false"
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: "sendInformationNo",
      className: "form-check-label"
    }, "No", /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "no send information")), /*#__PURE__*/React.createElement("div", {
      className: "valid-feedback"
    }, "Looks good!"), /*#__PURE__*/React.createElement("div", {
      className: "invalid-feedback"
    }, "Please select one option")))), /*#__PURE__*/React.createElement("div", {
      className: "text-center text-center grid-roommate__submit"
    }, /*#__PURE__*/React.createElement("button", {
      type: "submit",
      className: "btn btn-outline-main",
      disabled: this.state.loading
    }, this.state.loading ? 'LOADING...' : 'FIND A ROOMMATE')), this.state.success && /*#__PURE__*/React.createElement("div", {
      className: "alert alert-success alert-dismissible fade show grid-roommate__modalResult",
      role: "alert"
    }, /*#__PURE__*/React.createElement("strong", null, "Thank you!"), " We have received your request.", /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "close",
      onClick: this.handleclose,
      "data-dismiss": "alert",
      "aria-label": "Close"
    }, /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"))), this.state.error && /*#__PURE__*/React.createElement("div", {
      className: "alert alert-warning alert-dismissible fade show grid-roommate__modalResult",
      role: "alert"
    }, /*#__PURE__*/React.createElement("strong", null, "Please try again!"), " Has occurred an error while saving.", /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "close",
      onClick: this.handleclose,
      "data-dismiss": "alert",
      "aria-label": "Close"
    }, /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7")))), /*#__PURE__*/React.createElement(ReCaptcha, {
      ref: ref => {
        this.recaptchaRef = ref;
      },
      sitekey: PUBLIC_KEY,
      action: "submit"
    }), !this.state.captcha && /*#__PURE__*/React.createElement("span", {
      className: "invalid-feedback d-block"
    }, "Invalid Captcha!")));
  }
  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }
}
const _default = FormRoommateFinder;
export default _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(initialState, "initialState", "/var/www/html/websites/livecbm-com/src/frontend/components/FormRoommateFinder.jsx");
  reactHotLoader.register(FormRoommateFinder, "FormRoommateFinder", "/var/www/html/websites/livecbm-com/src/frontend/components/FormRoommateFinder.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/livecbm-com/src/frontend/components/FormRoommateFinder.jsx");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();